import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import topnotch_1 from './images/topnotch/topnotch_1'
import topnotch_2 from './images/topnotch/topnotch_2'
import topnotch_3 from './images/topnotch/topnotch_3'

export default function Contacts() {
  const [userData, setuserData] = useState({name:"", email:"", phone:'', subject:'',message:""})

  const userContact = async () => {
    try {
      const res = await fetch ('/getdata',{
        method:"POST",
        headers: {
          'Content-Type': 'application/json',
        }
       
      });
      const data = await res.json();
console.log(data);
setuserData({...userData,name:data.name, email:data.email, phone:data.phone})
if (!res.status === 200){
  const error = new Error(res.error);
  throw error;
}
    } 

 catch (err){
  console.log(err);
}
}
  const handleInputs = async (e)=>{
    const name = e.target.name;
    const value= e.target.value;
    setuserData({...userData , name:userData.name, email:userData.email, phone:userData.phone, subject:userData.subject, message:userData.message})
  }

  

  // useEffect(() => {
  //  userContact();
  //   },
  // [])

  const contactForm = async (e) => {
    e.preventDefault();
    const {name, email, phone, message, subject} = userData;
   const res = await fetch('/concat',{
    method:"GET",
    headers :{
      "Content-Type" : "application/json"
    },
    body :JSON.stringify({
      name, email, phone,message
    })
   });
const data = await res.json();
if(!data){
  console.log('message not send');
}else{
  alert('message send');
  setuserData({...userData, message:""});
}

  }
  
 
  return (
    <>
      <div
        className="inner-banner"
        style={{backgroundImage:`linear-gradient(rgba(0,0,0,0.1),rgba(0,0,0,0.7)) , 
        url(${topnotch_1})
        `}}
      >
        <img
          src="https://www.spinner-wp.egenslab.com/wp-content/themes/spinner/assets/images/bg/inner-bannerdot.png"
          className="inner-bannerdot"
          alt="image"
        />
        <img
          src="https://www.spinner-wp.egenslab.com/wp-content/themes/spinner/assets/images/bg/inner-bannerwave.png"
          className="inner-bannerwave"
          alt="image"
        />
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center text-center">
            <div className="col-md-12">
              <div className="text-center">
                <h2 className="inner-banner-title wow fadeInLeft">Contact Us </h2>
                <ul id="breadcrumb" className="breadcrumb gap-3">
                  <li className="breadcrumb-item">
                    <Link to="/"> Home </Link>
                  </li>
                  <li className="breadcrumb-item active">Contact Us</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-wrapper sec-mar">
        <article
          id="post-2098"
          className="post-2098 page type-page status-publish hentry"
        >
          <div className="inner-post">
            <div
              data-elementor-type="wp-page"
              data-elementor-id="2098"
              className="elementor elementor-2098"
            >
              <section
                className="elementor-section elementor-top-section elementor-element elementor-element-797108a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                data-id="797108a"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-default">
                  <div
                    className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-177750c"
                    data-id="177750c"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <section
                        className="elementor-section elementor-inner-section elementor-element elementor-element-0a916e9 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="0a916e9"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-no">
                          <div
                            className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-7e2ee33"
                            data-id="7e2ee33"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap"></div>
                          </div>
                          <div
                            className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-ce9a36a"
                            data-id="ce9a36a"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-b0b213f elementor-widget elementor-widget-spinner_heading"
                                data-id="b0b213f"
                                data-element_type="widget"
                                data-widget_type="spinner_heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="section-title  primary4 position-relative">
                                    <span>-Our Office-</span>
                                    {/* <h3>Office Near You</h3> */}
                                    <p className="para mb-0">
                                    Top Notch Media Works is the best Branding Agency in Maharashtra. We design your brand, not as Link profession it’s our passion.


                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-47db17d"
                            data-id="47db17d"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap"></div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </section>
              <section
                className="elementor-section elementor-top-section elementor-element elementor-element-353ae72 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                data-id="353ae72"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-default">
                  <div
                    className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-59242fb"
                    data-id="59242fb"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-45e2895 elementor-widget elementor-widget-spinner_contact"
                        data-id="45e2895"
                        data-element_type="widget"
                        data-widget_type="spinner_contact.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="address-card">
                            <div className="content">
                              <div className="header">
                                <div className="location">
                                <i className="bi bi-geo-alt-fill"></i>
                                </div>

                                <h3>Address</h3>
                              </div>
                              <ul className="address-list">
                                <li>
                                  <span>Address: </span>
                                  Office 212 ELDORA, Golden City Center, Behind Prozone Mall, Aurangabad, Maharashtra 431001


                                </li>
                              </ul>
                              {/* <ul className="address-list">
                                <li>
                                  <span>Phone: </span>
                                  +919158111116
                                </li>
                              </ul> */}
                              {/* <ul className="address-list">
                                <li>
                                  <span>Email: </span>
                                  topnotchmediaworks@gmail.com</li>
                              </ul> */}
                            </div>
                            <img
                              decoding="async"
                              src={topnotch_1}
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-a15e407"
                    data-id="a15e407"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-08cba1b elementor-widget elementor-widget-spinner_contact"
                        data-id="08cba1b"
                        data-element_type="widget"
                        data-widget_type="spinner_contact.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="address-card">
                            <img
                              decoding="async"
                              src={topnotch_2}
                              alt=""
                            />

                            <div className="content">
                              <div className="header">
                                <div className="location">
                                <i className="bi bi-telephone-fill"></i>
                                </div>
                                <h3>Phone Number</h3>
                              </div>
                              <ul className="address-list">
                                <li>
                                  <span> Phone:</span>
                                  +919158111116


                                </li>
                              </ul>
                             
                             
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-aaf40f2"
                    data-id="aaf40f2"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-b66a7ca elementor-widget elementor-widget-spinner_contact"
                        data-id="b66a7ca"
                        data-element_type="widget"
                        data-widget_type="spinner_contact.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="address-card">
                            <div className="content">
                              <div className="header">
                                <div className="location">
                                <i className="bi bi-envelope-fill"></i>
                                </div>

                                <h3>Email</h3>
                              </div>
                              
                              <ul className="address-list">
                                <li>
                                  <span>Email: </span>
                                  topnotchmediaworks@gmail.com

<br />
                                </li>
                              </ul>
                            </div>
                            <img
                              decoding="async"
                              src={topnotch_3}
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section
                className="elementor-section elementor-top-section elementor-element elementor-element-aa21765 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                data-id="aa21765"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-default">
                  <div
                    className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-bba4da4"
                    data-id="bba4da4"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <section
                        className="elementor-section elementor-inner-section elementor-element elementor-element-3b47925 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                        data-id="3b47925"
                        data-element_type="section"
                      >
                        <div className="elementor-container elementor-column-gap-no">
                          <div
                            className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-4beb3d9"
                            data-id="4beb3d9"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap"></div>
                          </div>
                          <div
                            className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-24b0d2a"
                            data-id="24b0d2a"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap elementor-element-populated">
                              <div
                                className="elementor-element elementor-element-3a8914a elementor-widget elementor-widget-spinner_heading"
                                data-id="3a8914a"
                                data-element_type="widget"
                                data-widget_type="spinner_heading.default"
                              >
                                <div className="elementor-widget-container">
                                  <div className="section-title  primary4 position-relative">
                                    <span>Contact Us</span>
                                    <h3>Let Get in Touch</h3>
                                    {/* <p className="para mb-0">
                                    Top Notch Media Works is the best Branding Agency in Maharashtra. We design your brand, not as Link profession it’s our passion.

                                    </p> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-683de6e"
                            data-id="683de6e"
                            data-element_type="column"
                          >
                            <div className="elementor-widget-wrap"></div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </section>
              <section
                className="elementor-section elementor-top-section elementor-element elementor-element-b150b95 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                data-id="b150b95"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-default">
                  <div
                    className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-422a13f"
                    data-id="422a13f"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-73ccd79 elementor-widget elementor-widget-shortcode"
                        data-id="73ccd79"
                        data-element_type="widget"
                        data-widget_type="shortcode.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="elementor-shortcode">
                            <div
                              role="form"
                              className="wpcf7"
                              id="wpcf7-f2663-p2098-o1"
                              lang="en-US"
                              dir="ltr"
                            >
                              <div className="screen-reader-response">
                                <p
                                  role="status"
                                  aria-live="polite"
                                  aria-atomic="true"
                                ></p>
                                <ul></ul>
                              </div>
                              <form
                             
                                // action="/contact-us/#wpcf7-f2663-p2098-o1"
                                method="POST"
                                className="wpcf7-form init"
                                noValidate="novalidate"
                                data-status="init"
                              >
                                {/* <div style={{display: "none"}}>
                                  <input
                                    type="hidden"
                                    name="_wpcf7"
                                    value="2663"
                                  />
                                  <input
                                    type="hidden"
                                    name="_wpcf7_version"
                                    value="5.6.3"
                                  />
                                  <input
                                    type="hidden"
                                    name="_wpcf7_locale"
                                    value="en_US"
                                  />
                                  <input
                                    type="hidden"
                                    name="_wpcf7_unit_tag"
                                    value="wpcf7-f2663-p2098-o1"
                                  />
                                  <input
                                    type="hidden"
                                    name="_wpcf7_container_post"
                                    value="2098"
                                  />
                                  <input
                                    type="hidden"
                                    name="_wpcf7_posted_data_hash"
                                    value=""
                                  />
                                </div> */}
                                <div className="row g-4">
                                  <div className="col-lg-6">
                                    <div className="form-inner">
                                      <span
                                        className="wpcf7-form-control-wrap"
                                        data-name="your-name"
                                      >
                                        <input
                                          type="text"
                                          name="name"
                                          value={userData.name}
                                          onChange={(e)=>{setuserData(e.target.value)}}
                                          size="40"
                                          className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                          aria-required="true"
                                          aria-invalid="false"
                                          placeholder="Your Name:"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="form-inner">
                                      <span
                                        className="wpcf7-form-control-wrap"
                                        // data-name="your-email"
                                      >
                                        <input
                                          type="email"
                                          name="email"
                                          onChange={handleInputs}
                                          value={userData.email}
                                          size="40"
                                          className="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-email"
                                          // aria-invalid="false"
                                          placeholder="Your E-mail:"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="form-inner">
                                      <span
                                        className="wpcf7-form-control-wrap"
                                        // data-name="number"
                                      >
                                        <input
                                          type="number"
                                          name="phone"
                                          onChange={handleInputs}
                                          value={userData.phone}
                                          size="40"
                                          className="wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-tel"
                                          aria-invalid="false"
                                          placeholder="Phone Number:"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="form-inner">
                                      <span
                                        className="wpcf7-form-control-wrap"
                                        data-name="subject"
                                      >
                                        <input
                                          type="text"
                                          name="subject"
                                          onChange={handleInputs}
                                          value={userData.subject}
                                          size="40"
                                          className="wpcf7-form-control wpcf7-text"
                                          // aria-invalid="false"
                                          placeholder="Subject:"
                                        />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="form-inner">
                                      <span
                                        className="wpcf7-form-control-wrap"
                                        data-name="message"
                                      >
                                        <textarea
                                          name="message"
                                          cols="40"
                                          onChange={handleInputs}
                                          value={userData.message}
                                          rows="10"
                                          className="wpcf7-form-control wpcf7-textarea"
                                          // aria-invalid="false"
                                          placeholder="Write A Question"
                                        ></textarea>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-lg-12 text-center">
                                    <input
                                      type="submit"
                                      // value="Send Now"
                                      onClick={contactForm}
                                      className="wpcf7-form-control has-spinner wpcf7-submit eg-btn btn--submit"
                                    />
                                  </div>
                                </div>
                                <div
                                  className="wpcf7-response-output"
                                  aria-hidden="true"
                                ></div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </div>

      {/* <div classNameName="container">
          <iframe src="https://www.google.com/maps/search/Office+212+ELDORA,+Golden+City+Center,+Behind+Prozone+Mall,+Aurangabad,+Maharashtra+431001/@19.875079,75.373229,10z?hl=en-GB" frameborder="0" scrolling="no" marginwidth="0" marginheight="0" title="Office 212 ELDORA, Golden City Center, Behind Prozone Mall, Aurangabad, Maharashtra 431001" aria-label="Office 212 ELDORA, Golden City Center, Behind Prozone Mall, Aurangabad, Maharashtra 431001"></iframe>
      </div> */}
    </>
  );
}
